import React, { CSSProperties } from 'react';
import { Form, Input, InputProps } from 'antd';
import { Rule } from 'antd/lib/form';
import './index.css'

interface InputPrefixProps extends InputProps {
  name: string;
  rules?: Rule[];
  prefix: string;
  stylesPrefix?: CSSProperties;
  placeholder?: string;
}

const InputPrefix: React.FC<InputPrefixProps> = ({ name, rules, prefix, stylesPrefix, placeholder, ...props }) => {


  return (
    <Form.Item name={name} rules={rules}>
      <Input
        style={props.style}
        rootClassName="item-input"
        autoComplete='off'
        prefix={<div style={stylesPrefix} className="input-prefix"><span className="prefix-text-item">{prefix}</span></div>}
        placeholder={placeholder}
        {...props}
      />
    </Form.Item>
  )
};

export default InputPrefix;

